import { observer } from "mobx-react-lite";
import { BoxProps, useToast, chakra, useBoolean } from "@chakra-ui/react";

import { Lang } from "@noli/core";
import { translate } from "@noli/business";

import { toast } from "@/utils/misc";
import { Editor_Words } from "@/utils/lang/editor";
import { translateAndCheck } from "@/utils/prompt";
import { WenxinOptions } from "../types";
import { postWenxin } from "../api";
import { Wenxin_Words } from "../lang";
import BizGenerateButton from "@/components/bussiness/BizGenerateButton";
import { GeneratePriceRules } from "@/modules/editor/hooks/useGenerateCost";

type WenxinSubmitButtonProps = {
  t: ReturnType<typeof useToast>;
  lang: Lang;
  opt: WenxinOptions;
  generateCount?: number;
} & BoxProps;
const WENXIN_COST = 10;

export const WenxinSubmitButton = observer<WenxinSubmitButtonProps>(
  ({ t, lang, opt, generateCount = 3, ...others }) => {
    const [isLoading, loadingOp] = useBoolean(false);
    const [w, h] = opt.size.split("*").map((s) => parseInt(s));

    async function onSubmit(): Promise<void> {
      // sanity check
      if (!opt.text) {
        toast(t, "warning", translate(Editor_Words["no-text-input-message"], lang));
        return;
      }
      loadingOp.on();
      if (!(await translateAndCheck(opt.text, t, lang, false, false))) {
        loadingOp.off();
        return;
      }
      loadingOp.off();

      // call api
      await postWenxin({
        t,
        lang,
        meta: {
          type: "wenxin",
          data: {
            wh: { w, h },
            ...opt,
          },
        },
      });
    }

    return (
      <BizGenerateButton
        mt="16px"
        size={{ w, h }}
        calcPriceProps={GeneratePriceRules.Wenxin}
        generateCount={generateCount}
        showCost
        useCoin="payed"
        buttonProps={{
          isLoading,
          disabled: isLoading,
        }}
        {...others}
        sticky
        onSubmit={onSubmit}
      >
        <chakra.span fontWeight={600} fontSize="13px">
          {translate(Wenxin_Words["wenxin-submit"], lang)}
        </chakra.span>
      </BizGenerateButton>
    );
  },
);
